import { render } from "./CombatLogsView.vue?vue&type=template&id=1135afeb"
import script from "./CombatLogsView.vue?vue&type=script&lang=js"
export * from "./CombatLogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__